import React from "react";
import { Grid, CircularProgress } from "@material-ui/core";

export const AppLoadingScreen = () => (
  <Grid
    container
    spacing={0}
    direction="column"
    alignItems="center"
    justify="center"
    style={{ minHeight: "100vh" }}
  >
    <Grid item style={{ textAlign: "center" }}>
      <CircularProgress size={150} />
      <h1>Loading...</h1>
    </Grid>
  </Grid>
);
